/**
 * SecName component.
 *
 * Displays the user's username and role in the profile header.
 * Shows semi-transparent background with rounded corners.
 *
 * @param {Object} props - Component props
 * @param {Object} props.profileInfo - User profile data with username, role
 * @returns {React.ReactElement} Username and role badge
 */
function SecName({profileInfo}){

  return(
      <div className="col-auto p-2 border-radius-xl my-auto bg-dark bg-opacity-50">
        <div className="h-100 w-100">
          <h5 className="mb-1 text-light">
              {profileInfo?.username}
          </h5>
          <p className="mb-0 fw-bold text-light text-sm">
              {profileInfo?.role}
          </p>
        </div>
      </div>
  )
}

export default SecName
